export default {
    appointment: 'Rendez-vous',
    sale: 'Vente',
    roadTest: 'Essai routier',
    visit: 'Visite',
    no_objective: 'Aucun objectif',
};
